import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=621abf28&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=621abf28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621abf28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621abf28')) {
      api.createRecord('621abf28', component.options)
    } else {
      api.reload('621abf28', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=621abf28&scoped=true&", function () {
      api.rerender('621abf28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZcGYy39i5V5m/JS/comp/GuestBox.vue"
export default component.exports